import { render, staticRenderFns } from "./ChampionPositions.vue?vue&type=template&id=302a4e50&scoped=true&"
import script from "./ChampionPositions.vue?vue&type=script&lang=js&"
export * from "./ChampionPositions.vue?vue&type=script&lang=js&"
import style0 from "./ChampionPositions.vue?vue&type=style&index=0&id=302a4e50&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "302a4e50",
  null
  
)

export default component.exports